import type { ImageAsset } from '../types/content';

/**
 * IMAGE SLOTS — swap each `src` for a real HPP photo.
 * `slot` describes what belongs there. Empty `src` renders a labeled placeholder.
 */
export const IMAGES = {
  hero: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/9f1aadba-d842-495a-beae-86f9a4a681ea.jpg',
    alt: 'Instructor coaching a student holding a pistol pointed safely downrange on an indoor range, both wearing eye and ear protection',
    slot: 'Hero — real class photo: instructor coaching on the range',
  },
  classroom: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/db13b49a-2363-4146-ad41-7cde84622abc.jpg',
    alt: 'CCW course workbook, pen and safety glasses on a classroom desk',
    slot: 'Bass Pro Shops Conservation Room classroom photo',
  },
  women: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/30b62990-a74b-4a0a-b7fe-b8189fc45876.jpg',
    alt: 'Woman aiming a pistol downrange with a female instructor beside her, both wearing eye and ear protection',
    slot: "Real women's class photo",
  },
  grip: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/1aff1bd5-094d-4319-a3c1-ced7b746d38b.jpg',
    alt: 'Close-up of hands with a proper two-hand pistol grip, finger off the trigger',
    slot: 'Real class photo: grip close-up',
  },
  holster: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/6e5decfe-27a5-44ad-9146-63f9c0dd2752.jpg',
    alt: 'Close-up of a concealed carry holster worn inside the waistband',
    slot: 'Real class photo: holster / concealed carry',
  },
  carbine: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/58a06f57-90b3-4b12-bdb9-480372d9ef07.jpg',
    alt: 'Student shouldering a carbine pointed downrange at a desert range while an instructor observes',
    slot: 'Real carbine class photo',
  },
  lowlight: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/df90db85-ba39-4c09-a5ea-31f3e409eff3.jpg',
    alt: 'Student using a weapon-mounted light on a target in a dim indoor range',
    slot: 'Real low light class photo',
  },
  students: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/5a8b1650-a52f-49bc-8848-efe1947b40d3.jpg',
    alt: 'Diverse group of students on a firing line listening to an instructor briefing',
    slot: 'Real class photo: group briefing on the firing line',
  },
  rangeWide: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/c3b20496-364d-4c14-9702-fbac0bc53426.jpg',
    alt: 'Empty indoor shooting range lanes with targets downrange',
    slot: 'Wide range photo for the final call to action',
  },
  homeDefense: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/819cf1a5-6e93-4273-b43c-273679bce041.jpg',
    alt: 'Student holding an inert training pistol at low ready during a home defense drill',
    slot: 'Real home defense class photo',
  },
  maggie: {
    src: '',
    alt: 'Maggie Mordaunt, CCW Maggie, founder and lead instructor',
    slot: 'Portrait — Maggie Mordaunt',
  },
  ken: {
    src: '',
    alt: 'Ken Ortega, owner and lead instructor',
    slot: 'Portrait — Ken Ortega',
  },
};

export type ImageKey = keyof typeof IMAGES;
export const imageList: ImageAsset[] = Object.values(IMAGES);
